import { Grid, Typography } from "@mui/material";
import * as React from "react";

import svg_i from "../assets/dashboard_animation.mp4";

const LoadingDashboard: React.FunctionComponent = (props) => {
  return (
    <Grid
      container
      item
      sx={{
        width: "100%",
        height: "100%",
      }}
      justifyContent="center"
      alignItems="center"
      direction="column"
    >
      <video
        className="videos"
        autoPlay={true}
        // onMouseOver={event => event.target.play()}
        // onMouseOut={event => event.target.pause()}
        muted={true}
        loop={true}
        src={svg_i}
      ></video>
      <Typography
        sx={{
          mt: 5,
          fontSize: "25px",
        }}
      >
        Please wait while your dashboard loads..
      </Typography>
    </Grid>
  );
};

export default LoadingDashboard;
